var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center"},[_c('v-icon',{staticClass:"mr-2",attrs:{"color":_vm.color}},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "+_vm._s(_vm.number)+" "+_vm._s(_vm.text)),(_vm.number > 1)?_c('span',[_vm._v("s")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }